import IdentitiesScene from '../scenes/IdentitiesScene';

const routes = [
  {
    path: '/identities/*',
    component: IdentitiesScene,
    exact: false,
    menuName: 'allIdentities',
    hasRight: 'identities/read-all',
    isActiveRoute: currentLocation => currentLocation.toLowerCase().startsWith('/identities'),
  },
];

export default routes;
